// extracted by mini-css-extract-plugin
export default {"actions":"TeaseFormActions_actions__gJ70u"};